import React, { Component } from 'react'
import { observer } from 'mobx-react'

import Form from '../../../../util/Form'
import { present } from '../../../../util/Form/validators'

import ResellerTeamsStore from '../../../../../stores/reseller_teams'

import { Link } from 'react-router'
import { up } from '../../../../../utils/url'

@observer
export default class AddResellerTeam extends Component {
  resellerTeams = new ResellerTeamsStore()

  handleData = data => {
    return this.resellerTeams.create(data).then(() => this.props.router.push(up(1)(this.props.location)))
  }

  render() {
    const validations = [
      { field: 'name', validate: present, message: 'All reseller teams must have a name' },
    ]

    return (
      <div className="container padded teams">
        <Form ref={el => this.form = el && el.form} className="full" validations={validations} onData={this.handleData}>
          <div className="panel full padded">
            <h2 className="title"><Link to={up(1)}>Reseller Teams</Link> / Add Team</h2>

            <div className="form-section">
              <label htmlFor="name">Reseller Team Name</label>
              <input name="name" id="name" placeholder="Enter a Name" />
            </div>

            <div className="form-section">
              <label htmlFor="broker">Broker</label>
              <input name="broker" id="broker" type="checkbox" value="true" />
            </div>

            <button type="submit" className="big shadowed">Add Reseller Team</button>
          </div>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/Admin/Resellers/Teams/AddTeam.js